import {qspost} from '@/plugins/axios'

/*
 * 登录
 * @constructor jack
 * */
export const login = (adminName, adminPass) => qspost('/Index/Common/login', {adminName, adminPass})

/*
 * 员工列表
 * @constructor jack
 * */
export const getAdminList = (searchName, searchPhone,power,page,pageSize) => qspost('/Index/Common/getAdminList', {searchName, searchPhone,power,page,pageSize})

/*
 * 员工添加
 * @constructor jack
 * */
export const createAdminAccount = (name,username, password,wordage,power,beizhu,sex,birthday,is_party,tags,xiaoqu_id,xiangmu_id,id
) => qspost('/Index/Common/createAdminAccount', {name,username, password,wordage,power,beizhu,sex,birthday,is_party,tags,xiaoqu_id,xiangmu_id,id})

/*
 * 修改密码
 * @constructor jack
 * */
export const setPass = (id,  password='Aa123456') => qspost('/Index/Common/updateAdminAccount', {id, password})

/*
 * 锁定/解锁
 * userLock 是否锁定1：锁定 0未锁定
 * @constructor jack
 * */
export const setLock = (id, userLock) => qspost('/Index/Common/updateAdminAccount', {id, userLock})

/*
 * 删除账号
 * @constructor jack
 * */
export const adminAccountDel = (id) => qspost('/Index/Common/adminAccountDel', {id})

/*
 * 账号信息详情
 * @constructor jack
 * */
export const adminAccountShow = (id) => qspost('/Index/Common/adminAccountShow', {id})

/*
 * 修改密码
 * @constructor jack
 * */
export const changePass = (oldPass, newPass, newRPass) => qspost('/Index/Common/changePass', {oldPass, newPass, newRPass})

/*
 * 修改密码
 * @constructor jack
 * */
export const setJdPass = (token,newPass, newRPass) => qspost('/Index/Common/setPass', {token,newPass, newRPass})

/*
 * 员工 绑定 管理小区
 * @constructor jack
 * */
export const yuanGongGuanLiXiaoQu = (xiangmuId, xiaoquId, yuanGongId,louHaoStrId,danYuanHaoStrId,id) => qspost('/Index/Xinxuqiu/yuanGongGuanLiXiaoQuNew', {xiangmuId, xiaoquId, yuanGongId,louHaoStrId,danYuanHaoStrId,id})

/*
 * 获得 员工 管理 小区的数据
 * @constructor jack
 * */
export const getYuanGongGuanLiXiaoQu = (yuanGongId) => qspost('/Index/Xinxuqiu/getYuanGongGuanLiXiaoQuNew', {yuanGongId})
